import nprogress from 'nprogress' // @types/nprogress
import {
  createRouter,
  createWebHashHistory,
  RouteLocationNormalized,
  RouteRecordRaw,
  START_LOCATION,
} from 'vue-router'
import 'nprogress/nprogress.css'

import Layout from '@/layout/default/Index.vue'
import { paths } from './paths'
import { useCommonStore } from '@/store/useCommonStore'
import { useAccessesStore } from '@/store/useAccesses'

import type { CustomRouteRecordRaw } from '@/router/typing'

const routes: CustomRouteRecordRaw[] = [
  {
    path: paths.redirect4login,
    component: () => import('@/views/redirect/Index.vue'),
  },
  {
    path: `${paths.share}/:id`,
    name: 'share',
    props: { editMode: true },
    component: () => import('@/views/disk/components/ShareView.vue'),
  },
  {
    path: paths.departmentRole,
    name: 'departmentRole',
    component: () => import('@/views/welcome/Welcome.vue'),
  },
  {
    path: paths.home,
    name: 'home',
    component: () => import('@/views/welcome/Home.vue'),
  },
  {
    path: `${paths.userAgreement}/:code`,
    name: 'userAgreement',
    component: () => import('@/views/welcome/UserAgreement.vue'),
  },
  {
    path: paths.root,
    meta: {
      title: 'Shield 2.0',
    },
    name: 'Shield 2.0',
    children: [
      {
        path: paths.root,
        redirect: paths.disk,
      },
      {
        path: paths.disk,
        name: 'NetDisk',
        meta: {
          // hiddenBreadcrumb: true,
        },
        component: () => import('@/views/disk/Index.vue'),
      },
      {
        path: paths.department,
        name: 'department',
        component: () => import('@/views/department/Index.vue'),
      },
      {
        path: paths.role,
        name: 'role',
        component: () => import('@/views/role/Index.vue'),
      },
      {
        path: paths.user,
        name: 'user',
        component: () => import('@/views/user/Index.vue'),
      },
      {
        path: paths.folder,
        name: 'folder',
        component: () => import('@/views/folder/Index.vue'),
      },
      {
        path: paths.log,
        name: 'log',
        component: () => import('@/views/log/Index.vue'),
      },
      {
        path: paths.dashboard,
        name: 'dashboard',
        component: () => import('@/views/dashboard/Index.vue'),
      },
      {
        path: paths.roleAdd,
        name: 'roleAdd',
        props: { editMode: false },
        component: () => import('@/views/role/components/Detail.vue'),
      },
      {
        path: paths.roleEdit,
        name: 'roleEdit',
        props: { editMode: true },
        component: () => import('@/views/role/components/Detail.vue'),
      },
      {
        // 403
        meta: {
          hiddenBreadcrumb: true,
        },
        name: '403',
        path: paths.forbidden,
        component: () => import('@/views/exceptions/403.vue'),
      },
      {
        // 404
        meta: {
          hiddenBreadcrumb: true,
        },
        name: '404',
        path: paths.notFound,
        component: () => import('@/views/exceptions/404.vue'),
      },
    ],
    component: Layout,
  },
  {
    // 404 跳转到首页(此配置必须处于路由最后一项)
    path: '/:catchAll(.*)',
    redirect: paths.notFound,
  },
]

const router = createRouter({
  routes: routes as RouteRecordRaw[],
  history: createWebHashHistory(), // createWebHistory
})

router.beforeEach(async (to: RouteLocationNormalized, from) => {
  const store = useCommonStore()
  try {
    if (
      from === START_LOCATION &&
      ![paths.home, paths.redirect4login, paths.forbidden, paths.notFound].includes(to.path)
    ) {
      // 开始加载进度条
      nprogress.start()
      if (!store.userInfo.id) {
        const redirect = await store.getCurrentUserInfo()
        if (redirect) return { path: redirect! }
      }
    }
  } catch (error) {
    return false
  }

  const accesses = useAccessesStore()

  const { matched } = to

  if (![paths.home, paths.forbidden, paths.notFound].includes(to.path)) {
    const notAllowed = matched.some((item: CustomRouteRecordRaw) => {
      if (typeof item.meta === 'undefined' || typeof item.meta.permission === 'undefined')
        return false
      return ([] as string[])
        .concat(item.meta.permission)
        .filter((auth) => typeof auth !== 'undefined')
        .some((auth) => accesses[auth] === false)
    })
    if (notAllowed) {
      return { path: paths.forbidden }
    }
  }
})

router.afterEach(() => {
  nprogress.done()
})

export default router
